<script setup>
import { computed, toValue } from "vue";
import PanelContainer from "./PanelContainerCI.vue";
import InferenceMultiSelect from "./InferenceMultiSelect.vue";
import { INFERENCE_FILTERS } from "../../constants.js";

import { useStore } from "vuex";

const store = useStore();

const cityFiltersEnabled = computed(() => {
  const featureFlags = store.state.featureFlags;
  return featureFlags["enable-ci-city-filter"];
});
const filtersToUse = computed(() => {
  return toValue(cityFiltersEnabled)
    ? INFERENCE_FILTERS
    : INFERENCE_FILTERS.filter((inferenceFilter) => inferenceFilter.paramName.toLowerCase() !== "city");
});

const registeredComponents = {
  InferenceMultiSelect,
};
</script>

<template>
  <template v-for="filter in filtersToUse">
    <div class="flex flex-col items-center w-full py-2 border-b border-gray-300">
      <panel-container
        :id="filter.paramName"
        :title="filter.title"
        :inference-key="filter.filterPath"
        main-panel-class="w-full"
        :panel-button-text-classes="['font-light normal-case']"
        heading-class="w-full py-3 text-sm items-center"
      >
        <component
          :is="registeredComponents[filter.component]"
          :filter-path="filter.filterPath"
          :getter="filter.getter"
          :display-name="filter.displayName"
        />
      </panel-container>
    </div>
  </template>
</template>
